export default __webpack_public_path__ + "static/media/Entradas.d58effe2.svg";